export enum OnboardingCompanyStatus {
  ONBOARDING_PROCESS_STARTED = 0,
  ONBOARDING_PROCESS_FINISHED,
  CAN_START_ONBOARDING,
}

export enum OnboardingContactStepResponse {
  EXISTS_WITH_DIFFERENT_ROLE = 0,
  EXISTS_WITH_SAME_ROLE,
  DOES_NOT_EXIST,
}
